import NotionEdit from '../components/NotionEdit/NotionEdit'

type NotionEditPageProps = {}

const NotionEditPage: React.FC<NotionEditPageProps> = () => {
  return <NotionEdit></NotionEdit>
}

export default NotionEditPage
